export default {
    getterSelectedStoreName: ({ storeDetail }) => {
        const storeName = storeDetail?.name;
        if (!storeName) {
            return '-';
        }
        return storeName;
    },
    getterSelectedStoreHubId: ({ storeDetail }) => storeDetail?.hubId,
};
